import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import ComicInformation from '@/components/disposable/ComicInformation.vue';
import { Comic, ComicStatus, ComicType } from '@/model/comic';
import { updateComic, getComic } from '@/repository/comic';
import { HttpStatusCode } from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateNovelView',
  setup(__props) {

const comicUUID = useRoute().params.comicUUID as string;
const store = useStore();
const { push } = useRouter();
const isLoading = ref(true);

const comic = ref<Comic>({
	imageURL: '',
	title: '',
	author: '',
	chapter: {},
	description: '',
	genres: [],
	note: '',
	status: ComicStatus.Ongoing,
	type: ComicType.Novel
});

onMounted(async () => {
	try {
		const res = await getComic(comicUUID);
		if (!res || res.status !== HttpStatusCode.Ok || !res.data) {
			throw Error('comic uuid is not found');
		}
		comic.value = res.data;
	} catch (error) {
		push(`/${comic.value.type}`);
	} finally {
		isLoading.value = false;
	}
});

async function submit(comic: Comic) {
	try {
		isLoading.value = true;
		const res = await updateComic(comic);
		if (res.data) {
			isLoading.value = false;
			store.dispatch('alert', { type: 'success', message: `Update ${comic.type} successfully!` });
			await push(`/${comic.type}/${comicUUID}`);
			return;
		}
		throw Error('Something went wrong, please try again!');
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComicInformation, {
    comicStatuses: [_unref(ComicStatus).Ongoing, _unref(ComicStatus).Complete],
    isLoading: isLoading.value,
    comic: comic.value,
    onSubmit: submit
  }, null, 8, ["comicStatuses", "isLoading", "comic"]))
}
}

})